(() => {
  if (document.querySelector(".template-product")) {
    document.addEventListener("DOMContentLoaded", () =>
      window.dispatchEvent(new Event("resize"))
    );

    const e = document.querySelectorAll(
        ".boost-pfs-quickview-selector-wrapper"
      ),
      t = document.querySelector(".product__select"),
      o = document.querySelector(".main-form"),
      r = document.querySelector(".product-form__submit"),
      i = document.querySelector(".minus-icon"),
      n = document.querySelector(".plus-icon"),
      a = document.querySelector("#Quantity-sub-main"),
      c = document.querySelectorAll(".product-sku .sku"),
      l = document.querySelector(".main-product__preloader");

    i.addEventListener("click", () => {
      a.value - 1 != 0 && a.setAttribute("value", a.value - 1);
    }),
      n.addEventListener("click", () => {
        parseInt(a.value) && a.setAttribute("value", parseInt(a.value) + 1);
      }),
      o.addEventListener("change", () => {
        l.classList.add("active");

        const e = document.querySelector(".main-product__container"),
          r = e.dataset.section,
          i = e.dataset.url,
          n = +t.value;

        fetch(`${i}?variant=${n}&section_id=${r}`)
          .then((e) => e.text())
          .then((e) => {
            const t = new DOMParser().parseFromString(e, "text/html"),
              r = document.querySelector(".main-product__price"),
              i = t.querySelector(".main-product__price"),
              n = document.querySelector(
                '[data-option-position="1"] .option-title__value'
              ),
              a = t.querySelector(
                '[data-option-position="1"] .option-title__value'
              ),
              c = document.querySelector(
                '[data-option-position="2"] .option-title__value'
              ),
              l = t.querySelector(
                '[data-option-position="2"] .option-title__value'
              ),
              s = document.querySelector(
                '[data-option-position="3"] .option-title__value'
              ),
              d = t.querySelector(
                '[data-option-position="3"] .option-title__value'
              ),
              u = document.querySelector(".product-gallery__thumbs"),
              p = t.querySelector(".product-gallery__thumbs"),
              m = document.querySelector(".product-gallery__main"),
              v = t.querySelector(".product-gallery__main");

            i && r && (r.innerHTML = i.innerHTML),
              a && n && (n.innerHTML = a.innerHTML),
              l && c && (c.innerHTML = l.innerHTML),
              d && s && (s.innerHTML = d.innerHTML),
              u && p && (u.innerHTML = p.innerHTML),
              m && v && (m.innerHTML = v.innerHTML),
              o.dispatchEvent(new Event("update-pdp-gallary", { bubbles: !0 }));
          })
          .finally(() => {
            l.classList.remove("active");
          });
      });

    // Function to get selected variant title string from all options
    function getSelectedVariantTitle() {
      var n = "";
      
      // Get all option wrappers sorted by position
      const optionWrappers = Array.from(e).sort((a, b) => {
        const posA = parseInt(a.querySelector('[data-option-position]')?.getAttribute('data-option-position') || '0');
        const posB = parseInt(b.querySelector('[data-option-position]')?.getAttribute('data-option-position') || '0');
        return posA - posB;
      });

      optionWrappers.forEach((wrapper, index) => {
        let selectedValue = "";
        
        // Check if it's a dropdown (Size)
        const dropdown = wrapper.querySelector('.product-option-select');
        if (dropdown && dropdown.value) {
          selectedValue = dropdown.value;
        } else {
          // Check for checked radio input first (most reliable)
          const checkedRadio = wrapper.querySelector('.boost-pfs-quickview-select-option:checked');
          if (checkedRadio) {
            selectedValue = checkedRadio.value;
          } else {
            // Fallback: Check for active swatch element
            const activeSwatch = wrapper.querySelector('.boost-pfs-swatch-element.is-active, .boost-pfs-swatch-element.selected');
            if (activeSwatch) {
              selectedValue = activeSwatch.getAttribute('data-value') || activeSwatch.getAttribute('data-handle');
            }
          }
        }

        if (selectedValue) {
          n = index == 0 ? selectedValue : `${n} / ${selectedValue}`;
        }
      });

      return n;
    }

    // Function to update variant selection
    function updateVariantSelection() {
      const variantTitle = getSelectedVariantTitle();
      
      if (!variantTitle) return;

      let variantFound = false;
      let previousValue = t.value;
      
      // Clear all selections first
      Array.from(t).forEach((option) => {
        option.selected = false;
      });
      
      // Find and select matching variant
      Array.from(t).forEach((option) => {
        if (option.dataset.title == variantTitle) {
          option.selected = true;
          variantFound = true;
          
          // Only update if the value actually changed
          if (t.value != option.value) {
            t.value = option.value;
          }
          
          c.forEach((skuElement) => {
            skuElement.dataset.id != option.getAttribute("value")
              ? skuElement.classList.remove("is-show")
              : skuElement.classList.add("is-show");
          });

          if (option.disabled) {
            r.setAttribute("disabled", "");
            if (r.firstElementChild) {
              r.firstElementChild.innerText = "Sold out";
            }
          } else {
            r.removeAttribute("disabled");
            if (r.firstElementChild) {
              r.firstElementChild.innerText = "Add to cart";
            }
          }
        }
      });

      // Trigger form change event to update price/gallery if variant changed
      if (variantFound && t.value && t.value != previousValue) {
        // Use setTimeout to ensure DOM is updated
        setTimeout(() => {
          t.dispatchEvent(new Event("change", { bubbles: true }));
          o.dispatchEvent(new Event("change", { bubbles: true }));
        }, 10);
      }
    }
    

    // Handle swatch/radio button clicks
    e.forEach((wrapper) => {
      const swatches = wrapper.querySelectorAll(".boost-pfs-swatch-element");
      
      swatches.forEach((swatch, index) => {
        swatch.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          
          // Remove active class from all swatches in this wrapper
          swatches.forEach((s, i) => {
            if (i != index) {
              s.classList.remove("is-active", "selected");
              const radio = s.querySelector('.boost-pfs-quickview-select-option');
              if (radio) {
                radio.checked = false;
              }
            } else {
              s.classList.add("is-active", "selected");
            }
          });

          // Update the radio input
          const radioInput = swatch.querySelector('.boost-pfs-quickview-select-option');
          if (radioInput) {
            radioInput.checked = true;
            radioInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          // Update option title value if it exists
          const optionTitle = wrapper.querySelector('.option-title');
          const optionTitleValue = optionTitle?.querySelector('.option-title__value');
          if (optionTitleValue) {
            const selectedValue = swatch.getAttribute('data-value') || radioInput?.value;
            if (selectedValue) {
              optionTitleValue.textContent = selectedValue;
            }
          }

          // Update variant selection immediately
          updateVariantSelection();
        });
      });
    });

    // Handle dropdown changes (for Size)
    e.forEach((wrapper) => {
      const dropdown = wrapper.querySelector('.product-option-select');
      if (dropdown) {
        dropdown.addEventListener("change", (event) => {
          event.stopPropagation();
          
          // Update option title value if it exists
          const optionTitle = wrapper.querySelector('.option-title');
          const optionTitleValue = optionTitle?.querySelector('.option-title__value');
          if (optionTitleValue) {
            optionTitleValue.textContent = dropdown.value;
          }

          // Update variant selection immediately
          updateVariantSelection();
        });
      }
    });

    // Also listen to radio input changes directly
    o.addEventListener("change", (event) => {
      if (event.target.classList.contains('boost-pfs-quickview-select-option') && 
          event.target.type === 'radio') {
        // Update the swatch visual state
        const swatch = event.target.closest('.boost-pfs-swatch-element');
        if (swatch) {
          const wrapper = swatch.closest('.boost-pfs-quickview-selector-wrapper');
          if (wrapper) {
            wrapper.querySelectorAll('.boost-pfs-swatch-element').forEach(s => {
              s.classList.remove('is-active', 'selected');
              const radio = s.querySelector('.boost-pfs-quickview-select-option');
              if (radio && radio != event.target) {
                radio.checked = false;
              }
            });
            swatch.classList.add('is-active', 'selected');
          }
        }
        updateVariantSelection();
      }
    });

    // Initialize variant selection on page load
    Array.from(t).forEach((variantOption) => {
      if (variantOption.selected && !variantOption.disabled) {
        const variantTitleParts = variantOption.dataset.title.split(" / ");

        // Get option wrappers sorted by position
        const optionWrappers = Array.from(e).sort((a, b) => {
          const posA = parseInt(a.querySelector('[data-option-position]')?.getAttribute('data-option-position') || '0');
          const posB = parseInt(b.querySelector('[data-option-position]')?.getAttribute('data-option-position') || '0');
          return posA - posB;
        });

        optionWrappers.forEach((wrapper, index) => {
          const optionValue = variantTitleParts[index];
          
          if (optionValue) {
            // Check if it's a dropdown
            const dropdown = wrapper.querySelector('.product-option-select');
            if (dropdown) {
              // Set dropdown value
              dropdown.value = optionValue;
              // Update option title value
              const optionTitleValue = wrapper.querySelector('.option-title__value');
              if (optionTitleValue) {
                optionTitleValue.textContent = optionValue;
              }
            } else {
              // Handle radio buttons/swatches
              const swatches = wrapper.querySelectorAll(".boost-pfs-swatch-element");
              swatches.forEach((swatch) => {
                const swatchValue = swatch.getAttribute("data-value");
                const radioInput = swatch.querySelector('.boost-pfs-quickview-select-option');
                const radioValue = radioInput?.value;
                
                if (swatchValue == optionValue || radioValue == optionValue) {
                  swatch.classList.add("is-active", "selected");
                  if (radioInput) {
                    radioInput.checked = true;
                  }
                  
                  // Update option title value
                  const optionTitleValue = wrapper.querySelector('.option-title__value');
                  if (optionTitleValue) {
                    optionTitleValue.textContent = optionValue;
                  }
                } else {
                  swatch.classList.remove("is-active", "selected");
                  if (radioInput) {
                    radioInput.checked = false;
                  }
                }
              });
            }
          }
        });

        // Update SKU display
        c.forEach((skuElement) => {
          skuElement.dataset.id != variantOption.getAttribute("value")
            ? skuElement.classList.remove("is-show")
            : skuElement.classList.add("is-show");
        });
      }
    });

    const s = document.querySelector(".main-product__accordions");

    s &&
      s.querySelectorAll(".main-product__accordion").forEach((e) => {
        e.querySelector(".title").addEventListener("click", () => {
          e.classList.toggle("active");
        });
      });
  }
})();